import React, { useEffect, useState } from 'react'
import { loadGA4, loadFBPixel, trackPageView } from '../../utils/tracking'

const FB_PIXEL_ID = '1226337109257372'
const GA4_TAG = 'G-SCN26RTCNN'

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consentGiven = localStorage.getItem('ga-consent') === 'true'
    if (!consentGiven) setVisible(true)
  }, [])

  function enableTracking() {
    loadGA4(GA4_TAG)
    loadFBPixel(FB_PIXEL_ID)
    // fire a pageview immediately after enabling
    trackPageView()
  }

  const handleAccept = () => {
    localStorage.setItem('ga-consent', 'true')
    enableTracking()
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 w-full bg-[#222] text-white p-4 z-50 text-center">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <div>
          <p className="m-0">
            Ο ιστότοπός μας χρησιμοποιεί cookies για να διασφαλίσει την καλύτερη δυνατή εμπειρία και
            να συλλέγει δεδομένα χρήσης. Συμφωνείτε;
          </p>
          <a
            href="/cookies-policy"
            className="text-sm underline text-gray-300 hover:text-white mt-1 block sm:inline sm:ml-2"
          >
            Πολιτική Cookies
          </a>
        </div>
        <button
          onClick={handleAccept}
          className="border border-white px-4 py-1 rounded-full hover:bg-white hover:text-black transition font-semibold text-sm md:text-base inline-flex items-center"
        >
          Αποδοχή
        </button>
      </div>
    </div>
  )
}

export default CookieBanner
